import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree, UrlSegment } from '@angular/router';
import { tap } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';

@Injectable()
export class AuthGuard  {

    constructor(
            private _authService: AuthService,
            private _router: Router
    ) {
    }

    public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
        return this._canAccess(state.url);
    }

    public canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
        return this._canAccess(state.url);
    }

    private _canAccess(url: string) {
        return this._authService.isLoggedIn().pipe(
                tap((isLogged: boolean) => {
                    if (!isLogged) {
                        this._authService.setRedirectUrl(url);
                        this._router.navigate(['login']);
                    }
                    return isLogged;
                })
        );
    }


}
